<div class="language-switcher">
  <button
    #languageTrigger
    type="button"
    class="language-switcher__trigger"
    aria-controls="language-switcher-popup"
    [attr.aria-expanded]="headerMenu.isLanguageOpen()"
    [attr.aria-label]="'language.current' | translate: { language: currentLanguage().name }"
    [title]="currentLanguage().name"
    (click)="toggleMenu()"
  >
    <span class="language-switcher__flag" aria-hidden="true">{{ currentLanguage().flag }}</span>
  </button>

  @if (headerMenu.isLanguageOpen()) {
    <div id="language-switcher-popup" class="language-switcher__menu" role="group" [attr.aria-label]="'language.menuLabel' | translate">
      @for (language of languages; track language.code) {
        <button
          type="button"
          class="language-switcher__option"
          [class.language-switcher__option--active]="language.code === currentLanguage().code"
          [attr.aria-pressed]="language.code === currentLanguage().code"
          (click)="selectLanguage(language.code)"
        >
          <span class="language-switcher__option-flag" aria-hidden="true">{{ language.flag }}</span>
          <span class="language-switcher__option-name">{{ language.name }}</span>
          <span class="language-switcher__option-indicator" aria-hidden="true"></span>
        </button>
      }
    </div>
  }
</div>
